import * as React from 'react';
import dynamic from 'next/dynamic';

import { useAppContext } from '../../contexts/AppContext';
import { Button } from '@mui/material';

import styled from '@emotion/styled';
import { CardTypeEnum } from '../../types/enum';
import { useTheme } from '@emotion/react';

import { GameMinimalProps, GameProps } from '../../types';
import { Link } from '../Link';
import ControlPointIcon from '@mui/icons-material/ControlPoint';

const LeftCarouselContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '.plus-warning-contained': {
    margin: '0 auto',
  },
  [theme.breakpoints.down(1500)]: {
    display: 'none',
  },
}));

const CarouselList = dynamic<any>(() => import('../../components/CarouselList').then((mod) => mod.CarouselList), {
  ssr: false,
});

export interface LeftCarouselProps {
  games: GameMinimalProps[] | GameProps[];
}

export const LeftCarousel = ({ games }: LeftCarouselProps) => {
  const theme = useTheme();

  const appContext = useAppContext();
  const { componentOptions } = appContext.useConfig();

  const carouselLeftSideShow = componentOptions?.component_gamescreen_left_game_carousel_show;
  const carouselLeftSideButtonRedirect = componentOptions?.component_gamescreen_left_game_carousel_button_redirect;

  const carouselLeftSideButtonText =
    componentOptions?.component_gamescreen_left_game_carousel_button_text || 'Recommended Games';

  if (carouselLeftSideShow) {
    return (
      <>
        {Array.isArray(games) && games.length > 0 && (
          <LeftCarouselContainer>
            <Link
              href={carouselLeftSideButtonRedirect || '/'}
              color="inherit"
              variant="inherit"
              underline="none"
              title=""
            >
              <Button color="warning" variant="contained" className="plus-warning-contained">
                {carouselLeftSideButtonText}
                <ControlPointIcon style={{ marginLeft: '8px' }} />
              </Button>
            </Link>
            <CarouselList
              padding={theme.spacing(2)}
              items={games}
              direction="vertical"
              cardOptions={{
                width: componentOptions.component_card_width || 512,
                height: componentOptions.component_card_height || 288,
                sizes: '(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw',
                layout: 'responsive',
                template: componentOptions?.component_game_carousel_card_type || CardTypeEnum.SIMPLE,
              }}
            />
          </LeftCarouselContainer>
        )}
      </>
    );
  } else {
    return <></>;
  }
};
